import { TileLayer, BitmapLayer, ScenegraphLayer, GeoJsonLayer, TextLayer, MVTLayer } from 'deck.gl';




export function renderLayers({ trackFrame }) {
 

  //OSMタイルを読み込みベースマップとして表示
  const tileLayer = new TileLayer({
    id:"tile-layer",
    data: "https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoic2hpbWl6dSIsImEiOiJjbGZwbDg3YnUwYWV2M3FubDdvN3pqcDhxIn0.WfKF0oFWPFqS6xn0Mm0Yow",
    minZoom: 0,
    maxZoom: 16,
    tileSize: 256,

    renderSubLayers: (props) => {
      const {
        bbox: { west, south, east, north }
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north]
      });
    }
  });  

  const model = new ScenegraphLayer({
    id: 'truck',
    data: trackFrame,
    scenegraph: "./model/marker.glb",
    sizeScale: 30,
    getPosition: d => d.point,
    getTranslation: [0, 0, 1],
    getOrientation: d => [0, 180 - d.heading, 90],
    _lighting: 'pbr'
  })

  const meText = new TextLayer({
    id: 'meText-layer',
    data: trackFrame,
    pickable: true,
    getPosition: d => [d.point[0], d.point[1], 20] ,
    getText: d => "C42",
    getSize: 32,
    getColor:[255, 255, 0],
    getAngle: 0,
    fontFamily:"Roboto", 
    fontWeight:"700",
    getTextAnchor: 'middle',
    getAlignmentBaseline: 'center'
  });

  const route = new GeoJsonLayer({
    id: 'geojson-layer',
    data:"./data/tokyo_route.geojson",
    pickable: false,
    stroked: true,
    filled: true,
    extruded: true,
    lineWidthScale: 3,
    lineWidthMinPixels: 2,
    getFillColor: [160, 160, 180, 200],
    getLineColor: [90, 180, 90],
    getLineWidth: 1,
    getElevation: 30
  });



  //建物データ(mvt)を読み込んで表示するレイヤ
  const building = new MVTLayer({
    id: "mvFIll",
    data: `https://indigo-lab.github.io/plateau-tokyo23ku-building-mvt-2020/{z}/{x}/{y}.pbf`,
    minZoom: 0,
    maxZoom: 16,
    getFillColor: [0, 255, 0, 120],
    lineWidthMinPixels: 1,
    pickable: true,
    extruded: true, //押出をonにする
    getElevation: (d) => d.properties.measuredHeight,
    wireframe: true, //lineを有効にする
    lineWidthMinPixels: 1,
    getLineColor: [255, 255, 0],
    material: {
      //立体ポリゴンのマテリアルを設定
      ambient: 0.9,
      diffuse: 0.1,
      shininess: 12,
      specularColor: [0, 255, 0]
    }
  });


  //レイヤーの重なり順を配列で指定(先頭のレイヤーが一番下になる)
  return [tileLayer, building, route, model, meText];
}
